import { Checkbox, FormControlLabel } from '@mui/material';
import * as React from 'react';

interface Props {
    hiddenCells: string[];
    setHiddenCells: any;
    dataKey: string;
    dataTitle: string;
}

export const InitToolBarItem: React.FC<Props> = (props: Props) => {
    const { hiddenCells, setHiddenCells, dataKey, dataTitle } = props;
    return (
        <FormControlLabel
            key={dataKey}
            control={
                <Checkbox
                    size={'small'}
                    checked={!hiddenCells.includes(dataKey)}
                    onChange={(e) => {
                        const { checked } = e.target;
                        setHiddenCells((prevState: any) => {
                            if (!checked) {
                                return [...prevState, dataKey];
                            } else {
                                return prevState.filter(
                                    (value: any) => value !== dataKey,
                                );
                            }
                        });
                    }}
                />
            }
            label={dataTitle}
        />
    );
};
